<div class="container mx-auto !p-0 lg:p-4">
  <h2 class="text-xl font-bold text-center">
    <mat-icon (click)="goBack()" class="float-left ms-4 cursor-pointer">arrow_back_ios</mat-icon>{{ 'ESIM.DETAILS.TITLE' | translate }}
  </h2>

  <!-- Loader dentro de la vista -->
  <div class="fullscreen-loader" *ngIf="isLoadingDetails">
    <div class="loader-content">
      <img src="https://cdn-dev.zendy.tel/images/Esim/EsimCard@2x.png" alt="eSIM" class="loader-esim-image" />
      <h2 class="loader-text">{{ 'ESIM.LOADING_DETAILS' | translate }}</h2>
      <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
    </div>
  </div>

  <!-- Contenido principal -->
  <div *ngIf="!isLoadingDetails">
  <div>
    <div class="container mx-auto !p-0 lg:p-4">
      <!-- Contenedor del eSIM -->
      <div class="esim-card-container">
        <mat-card class="esim-card w-full lg:max-w-[450px]">
          <div class="absolute left-0 ml-4 p-2 flex" style="height:fit-content;">
            <div *ngFor="let item of planType.split('-')">
              <img 
                width="16px" 
                [src]="'./assets/icons/' + (item || 'data') + '_ico.svg'" 
                [title]="item || 'data'" 
                class="mx-1" 
              />
            </div>
          </div>

          <div class="rounded-full bg-white absolute right-0 mr-4 p-2" style="height:fit-content;">
            <span class=" flag large block content-center"><img src="{{ countryimg }}" /></span>
          </div>

          <mat-card-header class="mb-2">
            <div class="esim-details-image-container relative float-end">
              <img src="https://cdn-dev.zendy.tel/images/Esim/EsimCard@2x.png" alt="eSIM Image" class="esim-details-image" />
              <span class="esim-details-country-label">{{ country }}</span> <!-- Aquí agregamos el país -->
            </div>
          </mat-card-header>

          <mat-card-content>
            <p><strong>{{ country | titlecase }}</strong></p>
            <p *ngIf="( iccid !== '')"><strong>ICCID: </strong>{{ iccid }}</p>
            <h2 class="m-1 text-5xl" *ngIf="price"><strong>{{ price | currency:'EUR':'symbol':'1.2-2':'es-ES' }}</strong></h2>
            <p><strong>{{ 'ESIM.OPERATOR' | translate }}: </strong> {{ operator }}</p>
          </mat-card-content>

          <mat-card-actions class="mat-card-actions" *ngIf="( iccid !== '')">
            <button mat-button class="recharge-button" (click)="onRecharge(iccid)">
              {{ 'ESIM.RECHARGE_NOW' | translate }}
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>

    <!-- Data Usage Section -->
    <div class="usage-section grid-cols-3" *ngIf="usageData && usageDataShow">
      <!-- Data -->
      <mat-card *ngIf="(usageData?.total != 0 && iccid !== '')" class="usage-card w-full">
        <mat-card-header>
          <div class="header-content flex justify-between">
            <mat-card-title class="usage-title">{{ 'ESIM.DETAILS.DATA' | translate }}</mat-card-title>
            <div class="usage-info">
              {{ 'ESIM.DETAILS.USED' | translate }}:
              {{ convertDataUnits(usageData?.total - usageData?.remaining || 0) }}
              {{ 'ESIM.OF' | translate }} {{ convertDataUnits(usageData?.total || 0) }}
            </div>
          </div>
        </mat-card-header>
        <mat-card-content>
          <mat-progress-bar mode="determinate"
                            [value]="calculatePercentage(usageData?.total || 0, usageData?.remaining || 0)"
                            class="custom-progress-bar">
          </mat-progress-bar>
          <p class="remaining-info">
            {{ 'ESIM.DETAILS.YOU_HAVE' | translate }} {{ convertDataUnits(usageData?.remaining || 0) }}
          </p>
        </mat-card-content>
      </mat-card>

      <!-- Voice -->
      <mat-card *ngIf="(usageData?.total_voice != 0 && iccid !== '')" class="usage-card w-full">
        <mat-card-header>
          <div class="header-content flex justify-between">
            <mat-card-title class="usage-title">{{ 'ESIM.DETAILS.VOICE' | translate }}</mat-card-title>
            <div class="usage-info">
              {{ 'ESIM.DETAILS.USED' | translate }}:
              {{ usageData.total_voice - usageData.remaining_voice }} min
              {{ 'ESIM.OF' | translate }} {{ usageData.total_voice }} min
            </div>
          </div>
        </mat-card-header>
        <mat-card-content>
          <mat-progress-bar mode="determinate"
                            [value]="calculatePercentage(usageData.total_voice, usageData.remaining_voice)">
          </mat-progress-bar>
          <p class="remaining-info">
            {{ 'ESIM.DETAILS.YOU_HAVE' | translate }} {{ usageData.remaining_voice }}
            {{ 'ESIM.DETAILS.MINUTES' | translate }}
          </p>
        </mat-card-content>
      </mat-card>

      <!-- SMS -->
      <mat-card *ngIf="(usageData?.total_text != 0 && iccid !== '')" class="usage-card w-full">
        <mat-card-header>
          <div class="header-content flex justify-between">
            <mat-card-title class="usage-title">SMS</mat-card-title>
            <div class="usage-info">
              {{ 'ESIM.DETAILS.USED' | translate }}:
              {{ usageData.total_text - usageData.remaining_text }} SMS
              {{ 'ESIM.OF' | translate }} {{ usageData.total_text }}
            </div>
          </div>
        </mat-card-header>
        <mat-card-content>
          <mat-progress-bar mode="determinate"
                            [value]="calculatePercentage(usageData.total_text, usageData.remaining_text)">
          </mat-progress-bar>
          <p class="remaining-info">
            {{ 'ESIM.DETAILS.YOU_HAVE' | translate }} {{ usageData.remaining_text }}
            {{ 'ESIM.DETAILS.MESSAGES' | translate }}
          </p>
        </mat-card-content>
      </mat-card>

    </div>
  </div>

  <div class="container mx-auto !p-0 lg:p-4 flex flex-col lg:flex-row gap-4 {{ iccid == '' ? '' : 'grid-cols-5' }}">

    <!-- QR Code Section -->
    <div class="qr-install-container lg:w-2/5 w-full h-fit" *ngIf="( iccid !== '')">
      <mat-card class="qr-card">
        <h2 class="text-xl font-bold">{{ 'ESIM.DETAILS.QR_AND_INSTALATION' | translate }}</h2>
        <mat-card-header>
          <!-- <mat-card-title class="text-red-600 font-bold">QR e instalación</mat-card-title> -->
        </mat-card-header>
        <mat-card-content class="mb-4">
          <!-- <p class="font-bold text-center text-lg">
      {{ 'ESIM.DETAILS.QR_TEXT' | translate }}
  </p> -->
          <div class="qr-image-container">
            <img [src]="esimDetails.details.qrcode_url" alt="QR Code" class="qr-code-image">
          </div>

          <div class="w-full my-6">
            <p class="font-bold mb-2">
              {{ 'ESIM.DETAILS.ACTIVATION_URL' | translate }}
            </p>
            <p class="w-full border p-2 rounded-md bg-white" *ngIf="installationGuide">{{installationGuide['ios'].installation_manual.smdp_address}}</p>
          </div>

          <div class="w-full my-6">
            <p class="font-bold mb-2">
              {{ 'ESIM.DETAILS.ACTIVATION_CODE' | translate }}
            </p>
            <p class="w-full border p-2 rounded-md bg-white" *ngIf="installationGuide">{{installationGuide['ios'].installation_manual.activation_code}}</p>
          </div>

          <p class="font-bold text-center text-lg">
            {{ 'ESIM.DETAILS.INSTALATION_INSTRUCTIONS' | translate }}
          </p>
          <div class="installation-buttons">
            <button mat-button class="install-button" (click)="selectPlatform('android')">
              <mat-icon>android</mat-icon> Android
            </button>
            <button mat-button class="install-button" (click)="selectPlatform('ios')">
              <mat-icon>apple</mat-icon> iOS
            </button>
          </div>
        </mat-card-content>

        <!-- Expansion Panel for Instructions -->
        <mat-expansion-panel *ngIf="selectedPlatform && installationGuide[selectedPlatform]"
                             class="installation-panel !m-2">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'ESIM.DETAILS.INSTALATION_INSTRUCTIONS_FOR' | translate }} {{ selectedPlatform | uppercase }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="installation-content">
            <div class="mt-2">
              <h4>{{ 'ESIM.DETAILS.QR_AND_INSTALATION' | translate }}</h4>
              <ul>
                <li *ngFor="let step of installationGuide[selectedPlatform].installation_via_qr_code.steps | keyvalue">
                  <label class="font-bold">
                    {{ 'ESIM.DETAILS.STEP' | translate }} {{ step.key }}:
                  </label> {{ step.value }}
                </li>
              </ul>
            </div>

            <div class="mt-2">
              <h4>{{ 'ESIM.DETAILS.MANUAL_INSTALATION' | translate }}</h4>
              <ul>
                <li *ngFor="let step of installationGuide[selectedPlatform].installation_manual.steps | keyvalue">
                  <label class="font-bold">
                    {{ 'ESIM.DETAILS.STEP' | translate }} {{ step.key }}:
                  </label> {{ step.value }}
                </li>
              </ul>
            </div>

            <div class="mt-2">
              <h4>{{ 'ESIM.DETAILS.NETWORK_SETUP' | translate }}</h4>
              <ul>
                <li *ngFor="let step of installationGuide[selectedPlatform].network_setup.steps | keyvalue">
                  <label class="font-bold">
                    {{ 'ESIM.DETAILS.STEP' | translate }} {{ step.key }}:
                  </label> {{ step.value }}
                </li>
              </ul>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-card>
    </div>

    <div class="card-details-container m-0 lg:m-12">
      <h2 class="text-xl font-bold mt-0">{{ 'ESIM.DETAILS.ADDITIONAL_INFORMATION' | translate }}</h2>
      <div *ngFor="let item of details | keyvalue">
        <div class=" flex justify-start mb-2" *ngIf="item.value != undefined">
          <div class="flex-none w-4 me-2"><img width="16" height="16" src="./assets/icons/sim_card.svg" /></div>
          <div class="w-fit flex-none font-bold me-2 ">{{ 'ESIM.DETAILS.'+item.key | uppercase | translate }}:</div>
          <div class=" ">{{ item.value+'' | titlecase | translate }}</div>
        </div>
      </div>

    </div>
  </div>

  <!-- Bloque de cantidad -->
  <div class="my-6 py-4 px-4 lg:px-16 mx-auto w-full lg:w-[70%] relative border rounded-md border-red-700"
      *ngIf="iccid == ''; else withIccd">

    <div class="flex-col text-center mb-2 flex justify-center items-center">
      <h4>{{ "ESIM.HOW_MUCH" | translate }}</h4>
      <div class="flex flex-row gap-4 w-full items-center justify-around">
        <div class="flex text-lg w-auto whitespace-nowrap">
          {{ price | currency:'EUR':'symbol':'1.2-2':'es-ES' }} x
        </div>

        <mat-form-field class="my-4 mr-4">
          <mat-label class="w-full">{{ "ESIM.QUANTITY" | translate }}</mat-label>
          <input matInput [(ngModel)]="quantity" type="number" min="1" [max]="limit" 
                (ngModelChange)="updatePrice($event)" />
        </mat-form-field>

        <div class="text-4xl text-light-red w-[60%] text-end">
          = {{ finalPrice | currency:'EUR':'symbol':'1.2-2':'es-ES' }}
        </div>
      </div>

      <app-promo></app-promo>
      <div *ngIf="priceBeforePromo" class="flex gap-2 float-end items-baseline">
        <i>{{ "COMMON.PROMO.DISCOUNT_TEXT" | translate }}</i>
        <span class="line-throug text-xl">
          {{ priceBeforePromo | currency:'EUR':'symbol':'1.2-2':'es-ES' }}
        </span>
      </div>
    </div>
  </div>


  <div class="text-center">
    <div class="text-center">
      <div class="check-full-width mb-2">
        <mat-label for="acceptTermsCheckbox">
          <input type="checkbox" id="acceptTermsCheckbox" name="acceptTermsCheckbox" [(ngModel)]="acceptTermsCheckbox">
          {{ 'ONBOARDING.REGISTER.TERMS_START' | translate }}
          <a href="/about/policy" target="_blank">{{ 'ONBOARDING.REGISTER.TERMS_PRIVACY' | translate }}</a>
          {{ 'ONBOARDING.REGISTER.TERMS_AND' | translate }}
          <a href="/about/conditions" target="_blank">{{ 'ONBOARDING.REGISTER.TERMS_TERMS' | translate }}</a>
        </mat-label>
      </div>

      <div class="check-full-width mb-2">
        <mat-label for="acceptDevicesCheckbox">
          <input type="checkbox" [(ngModel)]="acceptDevicesCheckbox" id="acceptDevicesCheckbox" name="acceptDevicesCheckbox">
          {{ 'ESIM.CONFIRM_DEVICES' | translate }}
          <a href="/about/esims" target="_blank">{{ 'ESIM.DEVICES' | translate }}</a>
        </mat-label>
      </div>

      <div class="text-center mb-2 flex justify-center items-center">
        <button
          mat-raised-button
          [disabled]="!acceptTermsCheckbox || !acceptDevicesCheckbox || !isQuantityValid()"
          color="primary"
          (click)="sendToProfile ? openProfileModal() : onBuyNow()">
          {{ 'ESIM.BUY_ESIM' | translate }}
        </button>
      </div>
    </div>


    <ng-template #withIccd>
      <!--<div class="text-center mb-2">
      <app-button mat-raised-button (click)="goBack()">{{ 'ESIM.DETAILS.BTN_BACK' | translate }}</app-button>
    </div>-->
    </ng-template>

    <div class="loading-mask" *ngIf="showSpinner">
      <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
    </div>
  </div>
  </div>
</div>
